import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ApiClient from '../../loopback/apiClient';
import { DigitalSurvey } from '../../redux/types';
import {
  setDigitalSurvey,
  showNotification,
} from '../../redux/actions';

type Props = {
  digitalSurvey: DigitalSurvey;
}

const DigitalTimerSetter: React.FC<Props> = ({
  digitalSurvey,
}: Props) => {
  const dispatch = useDispatch();
  const [textBuffer, setTextBuffer] = useState<number| ''>(digitalSurvey.time || '');

  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value !== '') {
      const numValue = parseInt(value, 10);
      setTextBuffer(numValue);
    } else {
      setTextBuffer(value);
    }
  };

  const onSetTimer = () => {
    ApiClient.updateDigitalSurvey({
      ...digitalSurvey,
      time: textBuffer === '' ? undefined : textBuffer,
    }).then((ds) => {
      dispatch(setDigitalSurvey(ds));
      dispatch(showNotification(<FormattedMessage id="genericSaveMessage" />));
    });
  };

  return (
    <>
      <FormControl
        size="small"
        sx={{
          maxWidth: 100,
          ml: 1,
          mr: 1,
        }}
      >
        <InputLabel htmlFor="add-timer">minutes</InputLabel>
        <OutlinedInput
          id="add-timer"
          type="number"
          value={textBuffer}
          onChange={onTextChange}
        />
      </FormControl>
      <Button color="tertiary" onClick={onSetTimer} variant="contained"><FormattedMessage id="save" /></Button>
    </>
  );
};

export default DigitalTimerSetter;
